import React from 'react';
import { cn } from '../../lib/utils';

export const Card = ({ children, className }) => {
  return (
    <div
      className={cn(
        'bg-card font-body border-4 border-border shadow-card rounded-xl p-4',
        className
      )}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className }) => {
  return (
    <div
      className={cn(
        'pb-2 mb-2 border-b-4 border-accent',
        className
      )}
    >
      {children}
    </div>
  );
};

export const CardTitle = ({ children, className }) => {
  return (
    <h3
      className={cn(
        'text-lg font-display text-primary uppercase tracking-widest mb-1',
        className
      )}
    >
      {children}
    </h3>
  );
};

export const CardDescription = ({ children, className }) => {
  return (
    <p
      className={cn(
        'text-muted-foreground text-xs font-body',
        className
      )}
    >
      {children}
    </p>
  );
};

export const CardContent = ({ children, className }) => {
  return (
    <div
      className={cn(
        'py-2',
        className
      )}
    >
      {children}
    </div>
  );
};

export const CardFooter = ({ children, className }) => {
  return (
    <div
      className={cn(
        'pt-2 mt-2 border-t-4 border-accent',
        className
      )}
    >
      {children}
    </div>
  );
};
